import { ApiConnection } from 'config'

const postConsulta = async (body) => {
  const { data } = await ApiConnection.post(`product/consulta`, body)
  return data.response
}

export default postConsulta
